module.exports = __webpack_public_path__ + "static/img/award5_a.e65e362.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/index/award5_a.png
// module id = S3Vm
// module chunks = 7